/**
* @Author: zachalam
* @Date:   2016-12-30T09:47:37-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-24T11:59:04-08:00
*/



import React from 'react';
import ReactDOM from 'react-dom';

import { Router, browserHistory } from 'react-router'
import routes from './routes';

import { Provider } from 'react-redux';


import store from './store';


ReactDOM.render(
  <Provider store={store}>
    <Router history={browserHistory} routes={routes} />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js